const PREFIX = 'Survey Connect_';

export const secureStorage = {
  async getItem(key: string): Promise<string | null> {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  async setItem(key: string, value: string): Promise<void> {
    try {
      localStorage.setItem(PREFIX + key, value);
    } catch (e) {
      console.warn('secureStorage.setItem failed', e);
    }
  },
  async removeItem(key: string): Promise<void> {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch (e) {
      console.warn('secureStorage.removeItem failed', e);
    }
  },
  async clear(): Promise<void> {
    try {
      const keys = Object.keys(localStorage).filter(k => k.startsWith(PREFIX));
      keys.forEach(k => localStorage.removeItem(k));
    } catch (e) {
      console.warn('secureStorage.clear failed', e);
    }
  },
};
